/*eslint no-undef: */
import './assets/css/R.scss';
// import Vue from 'vue';
import App from './App.vue';
import router from './plugins/router';
import store from './plugins/store';
import i18n from './plugins/i18n';
import vuetify from './plugins/vuetify';

import CheckEditor from './components/Editor/CheckEditor';
import ColorEditor from './components/Editor/ColorEditor';
import DateEditor from './components/Editor/DateEditor';
import DateTimeEditor from './components/Editor/DateTimeEditor';
import DecimalEditor from './components/Editor/DecimalEditor';
import FileEditor from './components/Editor/FileEditor';
import IntEditor from './components/Editor/IntEditor';
import MiniCheckEditor from './components/Editor/MiniCheckEditor';
import MiniDecimalEditor from './components/Editor/MiniDecimalEditor';
import MiniIntEditor from './components/Editor/MiniIntEditor';
import MiniJsonEditor from './components/Editor/MiniJsonEditor';
import MiniSelectEditor from './components/Editor/MiniSelectEditor';
import MiniTextareaEditor from './components/Editor/MiniTextareaEditor';
import MiniTextEditor from './components/Editor/MiniTextEditor';
import PathRefEditor from './components/Editor/PathRefEditor';
import PeriodEditor from './components/Editor/PeriodEditor';
import RefEditor from './components/Editor/RefEditor';
import SelectEditor from './components/Editor/SelectEditor';
import TableEditor from './components/Editor/TableEditor';
import Logger from './components/Logger';

Vue.use(CheckEditor);
Vue.use(ColorEditor);
Vue.use(DateEditor);
Vue.use(DateTimeEditor);
Vue.use(DecimalEditor);
Vue.use(FileEditor);
Vue.use(IntEditor);
Vue.use(MiniCheckEditor);
Vue.use(MiniDecimalEditor);
Vue.use(MiniIntEditor);
Vue.use(MiniJsonEditor);
Vue.use(MiniSelectEditor);
Vue.use(MiniTextareaEditor);
Vue.use(MiniTextEditor);
Vue.use(PathRefEditor);
Vue.use(PeriodEditor);
Vue.use(RefEditor);
Vue.use(SelectEditor);
Vue.use(TableEditor);
Vue.use(Logger);

import 'xe-utils';
import VxeTable from 'vxe-table';
import 'vxe-table/lib/style.min.css';
Vue.use(VxeTable);
import VxeTableColumnRender from './components/VxeTableColumnRender';
Vue.use(VxeTableColumnRender);


import VueStorage from 'vue-ls';
Vue.use(VueStorage, { namespace: 'rino__', name: 'ls', storage: 'local' });

import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

import directive from './plugins/directive';
Vue.use(directive);

import Message from './components/Message';
Vue.prototype.$message = Message;

import Utility from './plugins/utility';
Vue.prototype.Utility = Utility;

import { post } from './plugins/api';
Vue.prototype.$post = post;

Vue.config.productionTip = false

new Vue({ router, store, vuetify, i18n, render: h => h(App) }).$mount('#app')

